export const achievementData = {
    bio : "I educate, refine and drive myself to a better person. I am constantly learning. I stay calm when faced with Adversity. Highly passionate to develop web-based products and keen on finding solutions for the same.",
    achievements : [
        {
            id : 1,
            title : 'Python Development Course',
            details : 'Data types, functions, OOP, Django, Restful API',
            date : 'March, 2019',
            field : 'Python Programming',
            image : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFPu-ANpaIaP4Dy73ocmf75868TXqB04epuw&usqp=CAU'
        },
        {
            id : 2,
            title : 'M103: Basic Cluster Administration',
            details : '',
            date : 'Aug 20, 2019',
            field : 'Database',
            image : 'https://university.mongodb.com/course_completion/1fca81f1-9729-4a4e-832a-bf5e4d24cb09/printable?format=img'
        },
        {
            id : 3,
            title : 'M001: MongoDB Basic',
            details : 'About MongoDB Basics',
            date : 'Jul 20, 2020',
            field : 'Database',
            image : 'https://university.mongodb.com/course_completion/701f73c3-8132-495a-91c9-dd3caae9df24/printable?format=img'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/